import { element } from 'protractor';
/*
 * Inspinia js helpers:
 *
 * correctHeight() - fix the height of main wrapper
 * detectBody() - detect windows size
 * smoothlyMenu() - add smooth fade in/out on navigation show/ide
 *
*/

declare const jQuery: any;
declare var $: any;

export function correctHeight() {
  const pageWrapper = jQuery('#page-wrapper');
  const navbarHeigh = jQuery('nav.navbar-default').height();
  const wrapperHeigh = pageWrapper.height();

  if (navbarHeigh > wrapperHeigh) {
    pageWrapper.css('min-height', navbarHeigh + 'px');
  }

  if (navbarHeigh < wrapperHeigh) {
    if (navbarHeigh < jQuery(window).height()) {
      pageWrapper.css('min-height', jQuery(window).height() - 25 + 'px'); /* 98 */
    } else {
      pageWrapper.css('min-height', navbarHeigh + 'px');
    }
  }

  if (jQuery('body').hasClass('fixed-nav')) {
    if (navbarHeigh > wrapperHeigh) {
      pageWrapper.css('min-height', navbarHeigh + 'px');
    } else {
      pageWrapper.css('min-height', jQuery(window).height() - 25 + 'px'); /* 60 */
    }
  }
}

export function detectBody() {
  if (jQuery(document).width() < 769) {
    jQuery('body').addClass('body-small');
  } else {
    jQuery('body').removeClass('body-small');
  }
}

export function smoothlyMenu() {
  if (!jQuery('body').hasClass('mini-navbar') || jQuery('body').hasClass('body-small')) {
    // Hide menu in order to smoothly turn on when maximize menu
    jQuery('#side-menu').hide();
    // For smoothly turn on menu
    setTimeout(
      function () {
        jQuery('#side-menu').fadeIn(400);
      }, 200);
  } else if (jQuery('body').hasClass('fixed-sidebar')) {
    jQuery('#side-menu').hide();
    setTimeout(
      function () {
        jQuery('#side-menu').fadeIn(400);
      }, 100);
  } else {
    // Remove all inline style from jquery fadeIn function to reset menu state
    jQuery('#side-menu').removeAttr('style');
  }
}

export function tableHeadFixer(param) {

  function table() {
    const defaults = {
      head: true,
      foot: true,
      left: 0,
      right: 0,
      'z-index': 0
    };

    const settings = $.extend({}, defaults, param);

     /*
          This function solver z-index problem in corner cell where fix row and column at the same time,
          set corner cells z-index 1 more then other fixed cells
          */
          function setCorner() {
            // tslint:disable-next-line:no-shadowed-variable
            const table = $(settings.table);

            if (settings.head) {
                if (settings.left > 0) {
                    const tr = table.find('thead tr');

                    tr.each(function (k, row) {
                        solverLeftColspan(row, function (cell) {
                            $(cell).css('z-index', settings['z-index'] + 1);
                        });
                    });
                }

                if (settings.right > 0) {
                    const tr = table.find('thead tr');

                    tr.each(function (k, row) {
                        solveRightColspan(row, function (cell) {
                            $(cell).css('z-index', settings['z-index'] + 1);
                        });
                    });
                }
            }

            if (settings.foot) {
                if (settings.left > 0) {
                    const tr = table.find('tfoot tr');

                    tr.each(function (k, row) {
                        solverLeftColspan(row, function (cell) {
                            $(cell).css('z-index', settings['z-index']);
                        });
                    });
                }

                if (settings.right > 0) {
                    const tr = table.find('tfoot tr');

                    tr.each(function (k, row) {
                        solveRightColspan(row, function (cell) {
                            $(cell).css('z-index', settings['z-index']);
                        });
                    });
                }
            }
        }

        // Set style of table parent
        function setParent() {
            const parent = $(settings.parent);
            // tslint:disable-next-line:no-shadowed-variable
            const table  = $(settings.table);

            parent.append(table);
            parent
                .css({
                    'overflow-x': 'auto',
                    'overflow-y': 'auto'
                });

            parent.scroll(function () {
                const scrollWidth  = parent[0].scrollWidth;
                const clientWidth  = parent[0].clientWidth;
                const scrollHeight = parent[0].scrollHeight;
                const clientHeight = parent[0].clientHeight;
                const top          = parent.scrollTop();
                const left         = parent.scrollLeft();

                if (settings.head) {
                    this.find('thead tr > *').css('top', top);
                }
                if (settings.foot) {
                    this.find('tfoot tr > *').css('bottom', scrollHeight - clientHeight - top);
                }
                if (settings.left > 0) {
                    settings.leftColumns.css('left', left);
                }
                if (settings.right > 0) {
                    settings.rightColumns.css('right', scrollWidth - clientWidth - left);
                }
            }.bind(table));
        }

        // Set table head fixed
        function fixHead() {
            const thead = $(settings.table).find('thead');
            const tr    = thead.find('tr');
            const cells = thead.find('tr > *');

            setBackground(cells);

            cells.css({
                'position': 'relative',
                'box-shadow': 'inset 0px -2px 0px #ddd'
            });
        }

        // Set table foot fixed
         function fixFoot() {
            const tfoot = $(settings.table).find('tfoot');
            const tr    = tfoot.find('tr');
            const cells = tfoot.find('tr > *');

              setBackground(cells);
              cells.css({
                  'position': 'relative'
              });
        }

        // Set table left column fixed
        function fixLeft() {
            // tslint:disable-next-line:no-shadowed-variable
            const table = $(settings.table);

            // var fixColumn = settings.left;

            settings.leftColumns = $();

            const tr = table.find('tr');
            tr.each(function (k, row) {

                solverLeftColspan(row, function (cell) {
                    settings.leftColumns = settings.leftColumns.add(cell);
                });
                // var inc = 1;

                // for(var i = 1; i <= fixColumn; i = i + inc) {
                // 	var nth = inc > 1 ? i - 1 : i;

                // 	var cell = $(row).find("*:nth-child(" + nth + ")");
                // 	var colspan = cell.prop("colspan");

                // 	settings.leftColumns = settings.leftColumns.add(cell);

                // 	inc = colspan;
                // }
            });

            const column = settings.leftColumns;

            column.each(function (k, element2) {
                const cell = $(element2);

                setBackground(cell);
                cell.css({
                    'position': 'relative'
                });
            });
        }

        // Set table right column fixed
        function fixRight() {
            // tslint:disable-next-line:no-shadowed-variable
            const table = $(settings.table);

            const fixColumn = settings.right;

            settings.rightColumns = $();

            const tr = table.find('tr');
            tr.each(function (k, row) {
                solveRightColspan(row, function (cell) {
                    settings.rightColumns = settings.rightColumns.add(cell);
                });
            });

            const column = settings.rightColumns;

            column.each(function (k, element3) {
                const cell = $(element3);

                setBackground(cell);
                cell.css({
                    'position': 'relative'
                });
            });

        }

        // Set fixed cells backgrounds
        function setBackground(elements) {
          // tslint:disable-next-line:no-shadowed-variable
          elements.each(function (k, element) {
              const element1 = $(element);
              const parent  = $(element).parent();

              let elementBackground = element1.css('background-color');
               // tslint:disable-next-line:max-line-length
              elementBackground     = (elementBackground === 'transparent' || elementBackground === 'rgba(0, 0, 0, 0)') ? null : elementBackground;

              let parentBackground = parent.css('background-color');
               // tslint:disable-next-line:max-line-length
              parentBackground     = (parentBackground === 'transparent' || parentBackground === 'rgba(0, 0, 0, 0)') ? null : parentBackground;

              let background = parentBackground ? parentBackground : 'white';
              background     = elementBackground ? elementBackground : background;

              element1.css('background-color', background);
          });
        }

        function solverLeftColspan(row, action) {
            const fixColumn = settings.left;
            let inc       = 1;

            for (let i = 1; i <= fixColumn; i = i + inc) {
                const nth = inc > 1 ? i - 1 : i;

                const cell    = $(row).find('> *:nth-child(" + nth + ")');
                const colspan = cell.prop('colspan');

                if (cell.cellPos().left < fixColumn) {
                    action(cell);
                }

                inc = colspan;
            }
        }

        function solveRightColspan(row, action) {
            const fixColumn = settings.right;
            let inc       = 1;

            for (let i = 1; i <= fixColumn; i = i + inc) {
                const nth = inc > 1 ? i - 1 : i;

                const cell    = $(row).find('> *:nth-last-child(" + nth + ")');
                const colspan = cell.prop('colspan');

                action(cell);

                inc = colspan;
            }
        }
        settings.table  = this;
        settings.parent = $(settings.table).parent();
        setParent();

        if (settings.head === true) {
            fixHead();
        }

        if (settings.foot === true) {
            fixFoot();
        }
        setCorner();

        $(settings.parent).trigger('scroll');

        $(window).resize(function () {
            $(settings.parent).trigger('scroll');
        });
      }

  return $('#' + param).each(function () {
    table.call(this);
  });
}
